import React, { useContext, useEffect } from 'react';
import { NavItem, Nav } from 'react-bootstrap';
import cns from 'classnames';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import NavItemNoIcon from './NavItemNoIcon';
import { useDispatch, useSelector } from 'react-redux';
import CaptureClicksV2 from '../../components/CaptureClicksV2';
import { getManyBookmarks } from '../../../shared/actions/Bookmarks';
import VerbText from '../../../shared/components/VerbText';
import { RuntimeContext } from '../../../../common/RuntimeContext';

const MenuItems = ({ bookmarks }) => {
    const bookmarkElem = orderBy(bookmarks, 'createdOn', 'desc')
        .slice(0, 8)
        .map((bookmark) => {
            const { userLearningAssetId, sectionItemId, sectionId, _id, sectionItemName } = bookmark;
            return (
                <Nav.Link
                    href={`/workspace/${userLearningAssetId}?sectionItemId=${sectionItemId}&sectionId=${sectionId}`}
                    eventKey={`${_id}-${sectionItemId}`}
                    key={`${_id}-${sectionItemId}`}
                >
                    <div className={'row'}>
                        <i className={'fal fa-bookmark col-1 bookmark-row-icon'} />
                        <div className={'col-11'}>{sectionItemName}</div>
                    </div>
                </Nav.Link>
            );
        });
    return (
        <>
            <NavDropdown.Header>RECENT BOOKMARKS</NavDropdown.Header>
            {bookmarkElem}
        </>
    );
};

MenuItems.propTypes = {
    bookmarks: PropTypes.array
};

const NavBookmarksMenuItem = (props) => {
    const config = useContext(RuntimeContext);
    const { bookmarksActive, loggedInUser, handleNavigation } = props;
    const bookmarks = useSelector(({ bookmarks }) => bookmarks?.byId);
    const dispatch = useDispatch();

    let bookmarkList = [];
    useEffect(() => {
        dispatch(getManyBookmarks({ pathsContext: config.pathsWeb }));
    }, []);

    if (!isEmpty(bookmarks)) {
        bookmarkList = Object.values(bookmarks);
    }

    return (
        <NavItem
            title={'BOOKMARKS'}
            id={'nav-dropdown'}
            className={cns('navbar-section navbar-bookmarks navbar-dropdown-default', { selected: bookmarksActive })}
            onClick={() => handleNavigation(`/profile/${loggedInUser._id}/bookmarks`)}
        >
            <Nav.Link>
              <CaptureClicksV2>
                <NavItemNoIcon
                    key={'skillsIcon'}
                    textId={'NAVIGATION_BOOKMARKS'}
                    defaultMessage={'BOOKMARKS'}
                />
              </CaptureClicksV2>
            </Nav.Link>
        </NavItem>
    );
};

NavBookmarksMenuItem.propTypes = {
    bookmarksActive: PropTypes.bool,
    loggedInUser: PropTypes.object
};

export default NavBookmarksMenuItem;
